import React from 'react';
import ClearOutlinedIcon from '@material-ui/icons/ClearOutlined';
import SearchOutlinedIcon from '@material-ui/icons/SearchOutlined';
import { SearchInputStyled, BtnWrapperStyled } from './search-input.styled';
import { Input } from 'components/input/input/input';
import { IconButton } from '@material-ui/core';

type TSearchInput = {
    value?: string;
    width?: string;
    hasBtnCount?: number;
    showSearchBtn?: boolean;
    reset: () => void;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    refetch?: () => void;
    placeholder?: string;
};

const SearchInput: React.FC<TSearchInput> = ({
    value = '',
    hasBtnCount,
    showSearchBtn = true,
    width,
    reset,
    onChange,
    refetch,
    placeholder
}) => {
    const handleRefetch = (): void => {
        refetch && refetch();
    }

    return (
        <SearchInputStyled>
            <Input
                value={value}
                onChange={onChange}
                hasBtnCount={hasBtnCount}
                width={width}
                inputProps={{placeholder}}
            />
            <BtnWrapperStyled>
                {value &&
                    <IconButton
                        className={'reset-btn'}
                        onClick={() => reset()}
                        aria-label="reset"
                        size="small"
                    >
                        <ClearOutlinedIcon fontSize="small" />
                    </IconButton>
                }
                {showSearchBtn && <IconButton
                    className={'search-btn'}
                    onClick={handleRefetch}
                    aria-label="search"
                    size="small"
                >
                    <SearchOutlinedIcon fontSize="small" />
                </IconButton>}
            </BtnWrapperStyled>
        </SearchInputStyled>
    );
};

export default SearchInput;